const style = {
  input: {
    display: `block`,
    width: `100%`,
    padding: `5px 15px`,
    height: `40px`,
    border: `1px solid transparent`,
    // background: `#fff`,
    borderRadius: `0px`,
    fontSize: `14px`,
    background: `#f8f8f8`,
    outline: `none`
  }
}

export default style



// WEBPACK FOOTER //
// ./src/components/News/partials/PostEditor/style/input.js